"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
const Collapse = dynamic(() => import("antd/es/collapse"), { ssr: false });
const Empty = dynamic(() => import("antd/es/empty"), { ssr: false });
const Space = dynamic(() => import("antd/es/space"), { ssr: false });
const Spin = dynamic(() => import("antd/es/spin"), { ssr: false });
const Tabs = dynamic(() => import("antd/es/tabs"), { ssr: false });
import Image from "next/image";
import CommonImage from "./../../../common/image/CommonImage";
import FaqComponent from "./FaqComponent";
import HomePageService from "@/services/api/HomeService";

export default function FAQPage() {
  const [categories, setCategories] = useState([]);
  const [faqs, setFaqs] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState(null);

  useEffect(() => {
    HomePageService.getFaqsCategories().then((data) => {
      setCategories(data);
      if (data?.length) {
        setActiveKey(data[0].id.toString());
        loadFaqs(data[0].id);
      }
    });
  }, []);

  const loadFaqs = async (categoryId) => {
    setLoading(true);
    const data = await HomePageService.getFaqs(categoryId);
    setFaqs((prev) => ({ ...prev, [categoryId]: data }));
    setLoading(false);
  };

  const handleTabChange = (key) => {
    setActiveKey(key);
    if (!faqs[key]) {
      loadFaqs(key);
    }
  };
  const items = categories.map((cat) => ({
    key: cat.id.toString(),
    label: <span className="faq_tab_nav">{cat.name}</span>,
    children: faqs[cat.id]?.length ? (
      <Space direction="vertical" size={16} className="faq_accordions">
        {faqs[cat.id].map((faq, idx) => (
          <Collapse
            key={idx}
            accordion
            defaultActiveKey={["1"]}
            style={{ width: "100%", marginBottom: 16 }}
            items={[
              {
                key: "1",
                label: <span className="faq-label">{faq.question}</span>,
                children: (
                  <>
                    <div className="faq-answer-text">{faq.answer}</div>
                  </>
                ),
              },
            ]}
          />
        ))}
      </Space>
    ) : (
      <Empty description="কোনো FAQ পাওয়া যায়নি" />
    ),
  }));

  return (
    <section className="faq-page bg-animation section_padding">
      <div className="container">
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-10 md:col-start-2">
            <div className="section_title lg:mb-7 md:mb-5 mb-4">
              <h2 className="title">
                <span className="w-8 h-8">
                  <CommonImage
                    src="/images/admission-icon/faq-icon.png"
                    className="img-icon"
                    alt="faq Icon"
                  />
                </span>{" "}
                সচরাচর প্রশ্ন ও উত্তর
              </h2>
            </div>

            <div className="faq-wrapper">
              {categories?.length > 0 ? (
                <Tabs
                  activeKey={activeKey}
                  items={items}
                  className="faq_tabs"
                  onChange={handleTabChange}
                />
              ) : (
                <Empty description="কোনো FAQ পাওয়া যায়নি" />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
